import React, { useEffect, useState } from 'react'
import Container from '../../base/Container'
import Card from '../../controls/Card'
import { useToast } from '../../controls/Toast/ToastService';
import { MdErrorOutline, MdOutlineLocationOn, MdOutlineMonitor, MdOutlineSupportAgent } from 'react-icons/md';
import { FaUserDoctor } from 'react-icons/fa6';
import { GetAllByUserPublic } from '../../../configurations/crud/opdCentersCrud';
import { getLoginInfo } from '../../../configurations/auth/getLoginInfo';
import StatusContainer from '../../controls/StatusContainer';
import { EDoctorStatusBg, GetEDoctorStatusName } from '../../../configurations/enums/EDoctorStatus';
import { Link, useParams } from 'react-router-dom';
import LoadingContainer from '../../controls/LoadingContainer';
import Empty from '../../controls/Empty';
import useGlobalLoader from '../../../configurations/useGlobalLoader';

export default function StartOPD() {
    const { start, end } = useGlobalLoader()
    const [opdCenters, setOpdCenter] = useState([]);
    const [loding, setLoding] = useState(false);
    const toast = useToast();
    const loginInfo = getLoginInfo()


    useEffect(() => {
        getAllOpdCenters()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    function getAllOpdCenters() {
        setLoding(true);
        start()
        GetAllByUserPublic({ DoctorId: loginInfo.doctorId })
            .then((res) => {
                let mdata = res.data;
                if (mdata.result.succeeded) {
                    setOpdCenter(mdata.data);
                } else {
                    setOpdCenter([]);
                    //toast.open(mdata.result.message, <MdErrorOutline />, "danger");
                }
                setLoding(false);
                end()
            })
            .catch((errors) => {
                setOpdCenter([]);
                //toast.open(errors, <MdErrorOutline />, "danger");
                setLoding(false);
                end()
                toast.open("Internet not connected, please connect and refresh", <MdErrorOutline />, "danger", 5000)
            });
    }

    return (
        <Container>
            {!loding ? (
                opdCenters.length > 0 ? (
                    <div className="flex w-full justify-center px-2 py-4 sm:px-4">
                        <div className="grid w-full grid-cols-1 gap-6 lg:w-10/12 xl:w-8/12 md:grid-cols-2">
                            {opdCenters.map((item, index) => (
                                <Card key={index} isBorder={true}>
                                    <div className="flex flex-col gap-4 p-1 sm:p-2">

                                        {/* center info */}
                                        <div className="flex flex-col items-center text-center">
                                            <h3 className="text-xl font-bold text-gray-900">{item.centerName}</h3>
                                            <p className="mt-1 inline-flex items-center gap-1 text-sm text-gray-500">
                                                <MdOutlineLocationOn className="shrink-0 text-blue-500" />
                                                {item.address}
                                            </p>
                                            <div className="mt-3 inline-flex items-center gap-2 text-sm">
                                                <span className="text-gray-400">Doctor's Status</span>
                                                <StatusContainer bg={EDoctorStatusBg(item.doctorStatus)} text={GetEDoctorStatusName(item.doctorStatus)} />
                                            </div>
                                        </div>

                                        {/* actions */}
                                        <div className="grid grid-cols-3 gap-2">
                                            <Link
                                                to={"/doctor/" + item.id + "/center"}
                                                className="flex flex-col items-center justify-center gap-1.5 rounded-xl bg-green-500 p-4 text-white shadow-sm transition hover:bg-green-600 focus:outline-none focus:ring-2 focus:ring-green-400 active:scale-95"
                                            >
                                                <FaUserDoctor className="text-xl" />
                                                <span className="text-sm font-semibold">Doctor</span>
                                            </Link>
                                            <Link
                                                to={"/display/" + item.id + "/center"}
                                                className="flex flex-col items-center justify-center gap-1.5 rounded-xl bg-slate-500 p-4 text-white shadow-sm transition hover:bg-slate-600 focus:outline-none focus:ring-2 focus:ring-slate-400 active:scale-95"
                                            >
                                                <MdOutlineMonitor className="text-xl" />
                                                <span className="text-sm font-semibold">Display</span>
                                            </Link>
                                            <Link
                                                to={"/reception/" + item.id + "/center"}
                                                className="flex flex-col items-center justify-center gap-1.5 rounded-xl bg-blue-500 p-4 text-white shadow-sm transition hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-400 active:scale-95"
                                            >
                                                <MdOutlineSupportAgent className="text-xl" />
                                                <span className="text-sm font-semibold">Reception</span>
                                            </Link>
                                        </div>
                                    </div>
                                </Card>
                            ))}
                        </div>
                    </div>
                ) : (
                    <Empty>No OPD Centers Created.</Empty>
                )
            ) : (
                <div className="w-full">
                    <LoadingContainer text={"Getting centers to start OPD"} />
                </div>
            )}
        </Container>
    )
}